import {
  FileType,
  Pagination,
  PaymentStatusType,
  PlanPeriodType,
  PlanStatusType,
  SortingType,
  StoreStatusType,
} from "../../types/static.types";

export enum StoreActionTypes {
  GET_STORE_LIST = "GET_STORE_LIST",
  GET_STORE_DETAIL = "GET_STORE_DETAIL",
  GET_ALL_STORE_SMS_STATUS_DETAIL = "GET_ALL_STORE_SMS_STATUS_DETAIL",
  GET_STORE_SMS_STATUS_DETAIL = "GET_STORE_SMS_STATUS_DETAIL",
  PUT_STORE_TAP_PAY_CARD = "PUT_STORE_TAP_PAY_CARD",
  PUT_STORE_PLAN = "PUT_STORE_PLAN",
  POST_SEARCH_PAYMENT_HISTORY = "POST_SEARCH_PAYMENT_HISTORY",
  POST_SEARCH_POINT_HISTORY = "POST_SEARCH_POINT_HISTORY",
  DELETE_STORE_PLAN = "DELETE_STORE_PLAN",
}

type PaymentHistory = {
  amount: number;
  createdAt: string;
  description: string;
  historyType: "PLAN" | "DEPOSIT" | "SMS_BILLING";
  id: number;
  invoiceNo: string;
  item: string;
  paymentGatewayTxId: string;
  paymentStatus: PaymentStatusType;
  tapPayCardInfo: TapPayCardInfo;
};

type PointHistory = {
  afterPoint: number;
  createdAt: string;
  description: string;
  historyType: "DEPOSIT" | "SEND_SMS" | "CMS";
  id: number;
  paymentHistory?: PaymentHistory;
  point: number;
};

export type PlanType = {
  id: number;
  name: string;
  period: PlanPeriodType;
  price: number;
  status: PlanStatusType;
};

export type TapPayCardInfo = {
  binCode: string;
  country: string;
  countryCode: string;
  createdAt: string;
  funding: number;
  id: number;
  issuer: string;
  lastFour: string;
  level: string;
  type: number;
};

export type StoreProps = {
  createdAt: string;
  id: number;
  lastPaymentHistory?: PaymentHistory;
  logoPhotoFile?: FileType;
  name: string;
  nextPaymentDateTime: string;
  nextPlan?: PlanType;
  plan?: PlanType;
  planExpireDateTime: string;
  point: number;
  status: StoreStatusType;
  tapPayCardInfo?: TapPayCardInfo;
  inviteCode?: string;
  lastTrialDate: string;
};

export type StoreSMSDetail = {
  billingStatus: "OK" | "FAIL";
  smsSentCountThisMonth: number;
  store: StoreProps;
  unpayedSmsCount: number;
};

type PaymentLog = {
  amount: number;
  createdAt: string;
  description: "string";
  id: number;
  item: string;
  paymentGatewayTxId: string;
  paymentStatus: PaymentStatusType;
  tapPayCardInfo: TapPayCardInfo;
};

export type TapPayCard = {
  address?: string;
  email: string;
  name?: string;
  nationalId?: string;
  phoneNumber?: string;
  prime: string;
  zipCode?: string;
};

export type StoreState = {
  list: StoreProps[];
  store: StoreProps;
  smsList: StoreSMSDetail[];
  sms?: StoreSMSDetail;
  paymentLog: PostSearchPaymentHistoryType;
  pointLog: PostSearchPointHistoryType;
};

export type GetStoreListType = StoreProps[];

export type GetStoreDetailType = StoreProps;

export type PutStoreTapPayCardType = StoreProps;

export type PutStorePlanType = StoreProps;

export type DeleteStorePlanType = StoreProps;

export type PostSearchPaymentHistoryType = Pagination<PaymentLog>;

export type PostSearchPointHistoryType = Pagination<PointHistory>;

export type SearchConfig = {
  paging: {
    page: number;
    pageSize: number;
  };
  sorting?: {
    sort?: SortingType;
    sortFields?: string[];
  };
};

interface GetStoreList {
  type: typeof StoreActionTypes.GET_STORE_LIST;
  payload: GetStoreListType;
}

interface GetStoreDetail {
  type: typeof StoreActionTypes.GET_STORE_DETAIL;
  payload: GetStoreDetailType;
}

interface GetAllStoreSMSStatusDetail {
  type: typeof StoreActionTypes.GET_ALL_STORE_SMS_STATUS_DETAIL;
  payload: StoreSMSDetail[];
}

interface GetStoreSMSStatusDetail {
  type: typeof StoreActionTypes.GET_STORE_SMS_STATUS_DETAIL;
  payload: StoreSMSDetail;
}

interface PutStoreTapPayCard {
  type: typeof StoreActionTypes.PUT_STORE_TAP_PAY_CARD;
  payload: PutStoreTapPayCardType;
}

interface PutStorePlan {
  type: typeof StoreActionTypes.PUT_STORE_PLAN;
  payload: PutStorePlanType;
}

interface PostSearchPaymentHistory {
  type: typeof StoreActionTypes.POST_SEARCH_PAYMENT_HISTORY;
  payload: PostSearchPaymentHistoryType;
}

interface PostSearchPointHistory {
  type: typeof StoreActionTypes.POST_SEARCH_POINT_HISTORY;
  payload: PostSearchPointHistoryType;
}

interface DeleteStorePlan {
  type: typeof StoreActionTypes.DELETE_STORE_PLAN;
  payload: DeleteStorePlanType;
}

export type StoreAction =
  | GetStoreList
  | GetStoreDetail
  | GetAllStoreSMSStatusDetail
  | GetStoreSMSStatusDetail
  | PutStoreTapPayCard
  | PutStorePlan
  | PostSearchPaymentHistory
  | PostSearchPointHistory
  | DeleteStorePlan;
